import React from 'react';

import { useDeviceType, Image } from '@cian/ui-kit';
import cn from 'clsx';
import styles from './styles.css';

export interface IBannerProps {
  bannerImgPaths: {
    imgPathDesktop?: string;
    imgPathTablet?: string;
    imgPathMobile?: string;
  };
}

export const Banner: React.FC<IBannerProps> = ({
  bannerImgPaths: { imgPathDesktop, imgPathTablet, imgPathMobile },
}) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['wrapper'], styles[deviceType])}>
      <Image
        alt="баннер акции"
        borderRadius="4px"
        objectFit="cover"
        preloader
        sources={[
          {
            media: '(max-width: 960px)',
            srcset: `${imgPathTablet}, ${imgPathMobile}`,
          },
        ]}
        src={`${imgPathDesktop}`}
        theme="dark"
        title="Баннер акции"
      />
    </div>
  );
};
